<template>
  <div class="">
    <div
      class="container-login100"
      v-bind:class="{ 'ui loading segment': processing }"
    >
      <div class="wrap-login100" ref="loading_target">
        <div class="login100-form-title" style="height: 100px;">
          <h2 class="ui header">
            <img src="/images/icons/password_recovery.png" />
            <div class="content">
              {{ $t("password reset") }}
              <div class="sub header">
                {{ $t("student") }}
                <strong
                  >{{ student_info.id_card }} - {{ student_info.name }}</strong
                >
              </div>
              <div class="sub header">
                {{ $t("username") }}
                <strong>{{ student_info.username }}</strong>
              </div>
            </div>
          </h2>
        </div>
        <div class="login100-form validate-form" id="login_form">
          <div class="wrap-input100 validate-input m-b-18">
            <span class="label-input100">{{ $t("password") }}</span>
            <input
              class="input100"
              type="password"
              name="password"
              v-bind:placeholder="$t('password')"
              v-model="password"
            />
            <span class="focus-input100"></span>
          </div>
          <div class="wrap-input100 validate-input m-b-18">
            <span class="label-input100">{{
              $t("password confirmation")
            }}</span>
            <input
              class="input100"
              type="password"
              name="password_confirmation"
              v-bind:placeholder="$t('password confirmation')"
              v-model="password_confirmation"
            />
            <span class="focus-input100"></span>
          </div>
          <div class="ui grid" style="width:100%">
            <div class="eight wide column">
              <div class="container-login100-form-btn">
                <button
                  class="login100-form-btn"
                  type="submit"
                  style="width: 100%;"
                  v-on:click="do_reset"
                >
                  {{ $t("reset") }}
                </button>
              </div>
            </div>
            <div class="eight wide column">
              <language-login-selector />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageLoginSelector from "@/components/LanguageLoginSelector";
import { local_api, error_toast } from "@/utils";
import sha1 from "js-sha1";
import { success_toast } from "../../../utils";

export default {
  name: "StudentPortalPublicPasswordRecovery",
  components: { LanguageLoginSelector },
  data() {
    return {
      password_confirmation: "",
      password: "",
      processing: false,
      student_info: {},
    };
  },
  mounted() {
    let vm = this;
    let id = vm.$route.query.i;
    local_api(this, "post", "/student_portal/auth/do-check-recovery", {
      u: id,
    })
      .then(function(response) {
        vm.student_info = response;
      })
      .catch(function(err) {
        error_toast(err);
      })
      .finally(() => {
        this.processing = false;
      });
  },
  methods: {
    do_reset() {
      let vm = this;
      if (
        vm.password &&
        vm.password_confirmation &&
        vm.password == vm.password_confirmation
      ) {
        let id = vm.$route.query.i;
        this.processing = true;
        local_api(this, "post", "/student_portal/auth/do-reset-password", {
          u: id,
          p: sha1(vm.password),
        })
          .then(function() {
            success_toast(vm.$t("your password has been reseted"));
            setTimeout(() => {
              vm.$router.push({
                name: "StudentPortalPublicLogin",
              });
            }, 2000);
          })
          .catch(function(err) {
            error_toast(err);
          })
          .finally(() => {
            this.processing = false;
          });
      } else {
        error_toast(vm.$t("please check password and password confirmation"));
      }
    },
  },
  created() {},
};
</script>

<style></style>
